import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronDoubleRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronDoubleRight"><Path fillRule="evenodd" clipRule="evenodd" d="M7.00011 6.93945L12.0608 12.0001L7.00011 17.0608L5.93945 16.0001L9.93945 12.0001L5.93945 8.00011L7.00011 6.93945ZM14.0001 6.93945L19.0608 12.0001L14.0001 17.0608L12.9395 16.0001L16.9395 12.0001L12.9395 8.00011L14.0001 6.93945Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronDoubleRight;
